const properties = {
    /*baseURL: "http://localhost:8080/acsmbsaqip",*/
    /*baseURL: "https://stgreports.nsqip.facs.org/acsMbsaqip_api",*/
    baseURL: "https://reports.nsqip.facs.org/acsMbsaqip_api",
}
export default properties;